import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BatchDropDown from 'src/common/components/batchDropDown';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import {
    ProductErrorText,
    AlertIcon,
} from '../../../pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import {
    ItemsCardContainer,
    RowContainer,
    ColumnContainer,
    SetCount,
    Type,
    CardFooter,
    BatchConatiner,
    SetsAndItemsValues,
    WaringMessage,
    Title2,
    Title3,
    NoMatchError
} from './CondensedMobileView.styled';
import {
    isTransferSurgery,
    setCurrencyFormatWithoutSymbol,
    getCurrencySymbol,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import DeleteIcon from 'src/assets/images/Menu/DeleteIcon.svg';
import warning from 'src/assets/images/warning.svg';
import { sizes } from 'src/styles/Media.styled';
import AddCartButton from 'src/common/atomics/addCartButton/AddCartButton';
import AddCartIcon from '../../atomics/addCartButton/AddCartIcon';
import ColumnContainerItems from './ColumnContainerItems';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';

const CondensedMobileView = ({
    enableTemplateCardSpecificStyling,
    cardFooterWidth,
    setOrItemDetails,
    addBorder,
    addfullBorder,
    minWidth,
    isCounterButton,
    isOnlyPlusButton,
    removeCount,
    addCount,
    addCard,
    onSetItemClick,
    boxShadow,
    margin,
    fontSize,
    marginOnLargeDevice,
    marginOnMediumDevice,
    marginRight,
    typeFontSize,
    setNameColor,
    setNameFontSizeDesktop,
    setNameFontSizeMobile,
    clickable,
    setNameLetterSpacing,
    itemCardsContainerMinMobWidth,
    width,
    mobileWidth,
    cartFooterMargin,
    subitem = false,
    widthItem,
    marginOnMobileDevice,
    inputOnChange = () => { },
    tabDeviceWidth,
    tabDeviceLandscapeWidth,
    isconsignmentAddOrder,
    reviewPage,
    priceOverridePage,
    tabWidthPotrait,
    clipPath,
    minMobileWidth,
    updateItemsCount,
    parentIndex,
    index,
    quickOrderFlag,
    setIsQuantityMoreThan50 = () => { },
    waringMessage,
    description,
    cartPage,
    isEquityTemp,
    background,
    checked = { checked },
    inventoryShipping = false,
    handleLocationChange = () => { },
    selectedLocation,
    checkAll = false,
    isProductguidePage,
    showCheckBox = true,
    section,
    isItemDetailPage=false,
    isSetDetailPage=false,
    basePrice,
    extPrice,
    isEquity = false,
    isTemplateDetail = false,
    isFromTemplates = false,
    isFromSurgeryTemplate = false,
    isReviewSubmitScreen = false,
    isOrderScreen = false,
    isFromConsignmentAdd,
    deleteProduct = () => { },
    onBomClick = () => { },
    isConsignmentAdd,
    isOrderDetailTab = false,
    reviewScreen,
    isShippingScreen,
    isExpanded,
    onToggle,
    isCartScreenOrProductGuide = false,
    handleSetSelection = () => { },
    isProductGuideScreen = false,
    isProductDetails = false,
    setIsBatchSelected = () => { },
    isBatchSelected = false,
    isBundlesChildren = false,
    setBundleChildrenFlag = () => { },
    orderType = '',
    isEquityTemplate = false,
    isFromBundle = false,
    isEquityTemplateBundlePopup = false,
    isChildItem = false,
    productKeyBundle = '',
    selectedSegment = 0,
    isLastItem = false,
    minHeight,
    isSetDetail,
    isQuickOrder = false,
    isFromIndependentProductGuide = false,
    updateProductQuantity = () => { },
    childItemProductkey = '',
    isSurgery,
    cartProducts =[],
    isFromEquity=false
}) => {
    const {
        productCFN,
        cfn,
        quantity,
        brand,
        status,
        uom,
        type,
        isSet,
        bom,
        productAdded,
        businessRules,
        isPlaceHolderAdded,
        isDeleteButtonPresent,
    } = setOrItemDetails || {};    
    const [isItemAdded, setIsItemAdded] = useState(false);
    const [addedItemId, setAddedItemId] = useState(null);
    const currentItemId = productCFN || cfn || bom;
    useEffectWithErrorLogging(() => {
        if (addedItemId && addedItemId !== currentItemId) {
            setIsItemAdded(false);
            setAddedItemId(null);
        }
    }, [currentItemId, addedItemId]);

    const isProductAdded = productAdded ||
        setOrItemDetails?.isAdded ||
        setOrItemDetails?.added ||
        setOrItemDetails?.productAdded ||
        (isItemAdded && addedItemId === currentItemId);
    //  const [checkBoxInfo, setCheckBoxInfo] = useState({});
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const currencyISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.currencyISOCode
    );
    const { productBomDetails } = useSelector(
        (state) => state.checkProductBomReducer
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    const [quantityValue, setQuantityValue] = useState(0);
    const [expandedCard, setExpandedCard] = useState(false);
    const [allocatedData, setAllocatedData] = useState('');
    const [reservationBatch, setReservationBatch] = useState('');
    const { t } = useTranslation();
    const isTissueProduct = setOrItemDetails?.salesOrg === 'S030' ?? false;
    useEffectWithErrorLogging(() => {
        const limitTwoDigits = /^\d{0,2}$/;
        if (limitTwoDigits.test(quantity) && quantity !== '') {
            setQuantityValue(quantity == 0 ? '' : removeLeadingZeros(quantity));
        }
        return () => { };
    }, [quantity]);

    const productWithIsPlaceHolderSet = useSelector(
        (state) => state.surgeryDetailsReducer.productWithIsPlaceHolderSet
    );
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );
    const winWidth = window.innerWidth;
    const isMobileScreen = winWidth <= sizes.mobileDevice;    

    const checkString = (str) => {
        const regex = /^[a-zA-Z0-9 ./,()-]+$/;
        if (regex.test(str)) {
            return str;
        } 
        return '';
    };

    const getBrand = (brand='') => {
        if (Array.isArray(brand) && brand.length > 0) {
            return String(brand);
        }
        return brand;
    };

    const removeLeadingZeros = (val) => {
        return String(val).replace(/^0+/, '') || '0';
    };

    const modifiedBrand = getBrand(brand);
    const onlyStringBrand = checkString(modifiedBrand);    

    const isFixedWidth =
        !isFromSurgeryTemplate &&
        !isProductguidePage &&
        !isConsignmentAdd &&
        !isReviewSubmitScreen &&
        !isSetDetailPage &&
        !isItemDetailPage &&
        !isOrderDetailTab &&
        !isShippingScreen &&
        !reviewScreen;

    return (
        <>
            <ItemsCardContainer
                boxShadow={boxShadow}
                border={!isProductguidePage && { border: addBorder }}
                fullBorder={!isProductguidePage && addfullBorder}
                minWidth={{ minWidth: minWidth }}
                margin={margin}
                marginOnLargeDevice={marginOnLargeDevice}
                marginOnMediumDevice={marginOnMediumDevice}
                marginOnMobileDevice={marginOnMobileDevice}
                width={width}
                mobileWidth={mobileWidth}
                minMobileWidth={minMobileWidth}
                itemCardsContainerMinMobWidth={itemCardsContainerMinMobWidth}
                widthItem={widthItem}
                tabDeviceWidth={tabDeviceWidth}
                tabDeviceLandscapeWidth={tabDeviceLandscapeWidth}
                backgroundColor={subitem ? '#FBFAFF' : null}
                tabWidthPotrait={tabWidthPotrait}
                clipPath={clipPath}
                background={background}
            >
                <RowContainer
                    contentPadding={
                        isOrderDetailTab
                            ? '10px 10px 10px 0px '
                            : isMobileScreen
                                ? isExpanded
                                    ? '10px 15px 10px 0px'
                                    : isEquityTemplate && isBundlesChildren
                                        ? '5px 0px 5px 0px'
                                        : '5px 15px 5px 2px '
                                : '10px 0px 10px 0px '
                    }
                    enableTemplateCardSpecificStyling={
                        enableTemplateCardSpecificStyling
                    }
                    border={!isFromBundle && '1px solid lightgray'}
                    isBundlesChildren={isBundlesChildren}
                    isLastItem={isOrderScreen ? isLastItem : false}
                >
                    <ColumnContainerItems
                        isEquityTemplate={isEquityTemplate}
                        countryISOCode={countryISOCode}
                        isBundlesChildren={isBundlesChildren}
                        isCartScreenOrProductGuide={isCartScreenOrProductGuide}
                        setOrItemDetails={setOrItemDetails}
                        isExpanded={isExpanded}
                        isOrderScreen={isOrderScreen}
                        expandedCard={expandedCard}
                        onToggle={onToggle}
                        setExpandedCard={setExpandedCard}
                        setBundleChildrenFlag={setBundleChildrenFlag}
                        onSetItemClick={onSetItemClick}
                        setNameColor={setNameColor}
                        clickable={clickable}
                        setNameFontSizeDesktop={setNameFontSizeDesktop}
                        setNameFontSizeMobile={setNameFontSizeMobile}
                        setNameLetterSpacing={setNameLetterSpacing}
                        enableTemplateCardSpecificStyling={enableTemplateCardSpecificStyling}
                        reviewPage={reviewPage}
                        priceOverridePage={priceOverridePage}
                        isShippingScreen={isShippingScreen}
                        isSetDetailPage={isSetDetailPage}
                        isconsignmentAddOrder={isconsignmentAddOrder}
                        isEquity={isEquity}
                        isTemplateDetail={isTemplateDetail}
                        orderType={orderType}
                        isProductGuideScreen={isProductGuideScreen}
                        reviewScreen={reviewScreen}
                        isLanguageChanged={isLanguageChanged}
                        isFromTemplates={isFromTemplates}
                        isFromSurgeryTemplate={isFromSurgeryTemplate}
                        isProductguidePage={isProductguidePage}
                        isConsignmentAdd={isConsignmentAdd}
                        isReviewSubmitScreen={isReviewSubmitScreen}
                        isItemDetailPage={isItemDetailPage}
                        isOrderDetailTab={isOrderDetailTab}
                        productBomDetails={productBomDetails}
                        cartPage={cartPage}
                        onBomClick={onBomClick}
                        marginRight={marginRight}
                        fontSize={fontSize}
                        typeFontSize={typeFontSize}
                        isProductDetails={isProductDetails}
                        isChildItem={isChildItem}
                        handleSetSelection={handleSetSelection}
                        productKeyBundle={productKeyBundle}
                        productWithIsPlaceHolderSet={productWithIsPlaceHolderSet}
                        shipDontShipSurgery={shipDontShipSurgery}
                        inventoryShipping={inventoryShipping}
                        handleLocationChange={handleLocationChange}
                        selectedLocation={selectedLocation}
                        allocatedData={allocatedData}
                        isCounterButton={isCounterButton}
                        quantityValue={quantityValue}
                        isQuickOrder={isQuickOrder}
                        removeCount={removeCount}
                        quickOrderFlag={quickOrderFlag}
                        updateItemsCount={updateItemsCount}
                        parentIndex={parentIndex}
                        index={index}
                        setIsQuantityMoreThan50={setIsQuantityMoreThan50}
                        setQuantityValue={setQuantityValue}
                        subitem={subitem}
                        inputOnChange={inputOnChange}
                        updateProductQuantity={updateProductQuantity}
                        childItemProductkey={childItemProductkey}
                        addCount={addCount}
                        isFromConsignmentAdd={isFromConsignmentAdd}
                        isFromIndependentProductGuide={isFromIndependentProductGuide}
                        isOnlyPlusButton={isOnlyPlusButton}
                        isProductAdded={isProductAdded}
                        addCard={addCard}
                        selectedSegment={selectedSegment}
                        isSurgery= {isSurgery}
                        showCheckBox={showCheckBox}
                        isFromEquity={isFromEquity}
                        isEquityPage={isFromEquity}
                        cartProducts={cartProducts}
                        isEquityTemplateBundlePopup={isEquityTemplateBundlePopup}
                    />
                    {!expandedCard && isShippingScreen && !isTissueProduct ? (
                        <RowContainer contentPadding={'0px'}>
                            {' '}
                            {((shipDontShipSurgery !== 'NOT_VISIBLE' ||
                                setOrItemDetails?.isReservationSet) &&
                                isShippingScreen) ||
                                showCheckBox ? (
                                <BatchConatiner
                                    margin={
                                        checked ? '0px 0px 6px 16px' : '0px'
                                    }
                                    mbBottom={
                                        checked ? '6px' : '0px'
                                    }
                                >
                                    <BatchDropDown
                                        checkAll={checkAll}
                                        checked={
                                            !setOrItemDetails.shippingRequirement
                                        }
                                        countryISOCode={countryISOCode}
                                        selectedLocation={selectedLocation}
                                        setIsBatchSelected={setIsBatchSelected}
                                        isBatchSelected={isBatchSelected}
                                        allocatedData={allocatedData}
                                        setAllocatedData={setAllocatedData}
                                        setReservationBatch={
                                            setReservationBatch
                                        }
                                        product={setOrItemDetails}
                                        isShowCheckBox={false}
                                        isMessageDisplay={true}
                                        isShowLabelEmpty={false}
                                        isShowSetLocation={false}
                                        isShowDropDown={true}
                                    />

                                    {isShippingScreen &&
                                        setOrItemDetails?.batchAllocationError && (
                                            <ProductErrorText>
                                                <AlertIcon
                                                    src={AlertCircleOutline}
                                                    height="14px"
                                                    width="auto"
                                                />
                                                <div>
                                                    {t(
                                                        'scheduleSurgery.Shipping.ProductCard.batchAllocationError'
                                                    )}
                                                </div>
                                            </ProductErrorText>
                                        )}
                                </BatchConatiner>
                            ) : null}
                        </RowContainer>
                    ) : (
                        <></>
                    )}

                    {(
                        isCartScreenOrProductGuide
                            ? isExpanded
                            : isOrderScreen
                                ? isExpanded
                                : isBundlesChildren
                                    ? true
                                    : expandedCard
                    ) ? (
                        <>
                            {' '}
                            <ColumnContainer
                                alignItems={isBundlesChildren && 'baseline'}
                            >
                                <RowContainer
                                    contentPadding={
                                        isLanguageChanged
                                            ? '0px 15px 0px 22px'
                                            : window.innerWidth < 380
                                                ? '0px 0px 0px 16px'
                                                : '0px 15px 0px 16px'
                                    }
                                    marginTop={'-10px'}
                                    marginTopScreen={isEquity ? '2px' : '0px'}
                                    width={isBundlesChildren && '75%'}
                                >
                                    <CardFooter
                                        cartFooterMargin={cartFooterMargin}
                                        cardFooterWidth={cardFooterWidth}
                                        enableTemplateCardSpecificStyling={
                                            enableTemplateCardSpecificStyling
                                        }
                                        justifyContentWithoutBrand={
                                            !brand && (uom || type)
                                        }
                                        display={isProductguidePage && 'block'}
                                    >
                                        <SetsAndItemsValues
                                            isEquityTemp={isEquityTemp}
                                            marginLeft={
                                                isBundlesChildren && '10px'
                                            }
                                            width={
                                                isBundlesChildren
                                                    ? '70%'
                                                    : '95%'
                                            }
                                            style={{
                                                textTransform: 'capitalize',
                                            }}
                                            marginTop={'0px'}
                                            minWidth={
                                                isBundlesChildren && '245px'
                                            }
                                        >
                                            {' '}
                                            {description ?
                                                <Title3 minHeight={minHeight}>
                                                    {description?.toLowerCase()}
                                                </Title3>
                                                :
                                                (quantity === 0 && isQuickOrder) ?
                                                    <NoMatchError>
                                                        {t('scheduleSurgery.quickOrder.noMatchingProductFound')}
                                                    </NoMatchError>
                                                    : null
                                            }
                                        </SetsAndItemsValues>
                                    </CardFooter>
                                    {onlyStringBrand ? (
                                        <>
                                            <SetsAndItemsValues
                                                isEquityTemp={isEquityTemp}
                                                marginLeft={
                                                    isBundlesChildren && '10px'
                                                }
                                                minWidth={
                                                    isBundlesChildren && '260'
                                                }
                                                width={
                                                    isBundlesChildren
                                                        ? '70%'
                                                        : '95%'
                                                }
                                                marginBottom={'-1px'}
                                                style={{
                                                    textTransform: 'capitalize',
                                                }}
                                                marginTop={'0px'}
                                            >
                                                <Title2>
                                                    {t(
                                                        'scheduleSurgery.surgery.notifications.itemListView.brand'
                                                    )}
                                                    :
                                                </Title2>{' '}
                                                <Title2
                                                    color={'#4C4C6C'}
                                                    fontFamily={
                                                        'AvenirNextWorld Regular'
                                                    }
                                                >
                                                    {onlyStringBrand?.toLowerCase()}
                                                </Title2>
                                            </SetsAndItemsValues>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                    {status ? (
                                        <SetsAndItemsValues
                                            marginLeft={
                                                isBundlesChildren && '10px'
                                            }
                                            width={'95%'}
                                            style={{
                                                textTransform: 'capitalize',
                                            }}
                                            marginTop={'0px'}
                                        >
                                            {' '}
                                            <Title2>
                                                {t(
                                                    'orders.orderListView.statusLabel'
                                                )}
                                                :
                                            </Title2>{' '}
                                            <Title2
                                                color={'#4C4C6C'}
                                                fontFamily={
                                                    'AvenirNextWorld Regular'
                                                }
                                            >
                                                {status?.toLowerCase()}
                                            </Title2>
                                        </SetsAndItemsValues>
                                    ) : null}
                                    {cartPage &&
                                        businessRules &&
                                        businessRules?.length > 0
                                        ? businessRules.map((msg, index) => {
                                            return (
                                                <WaringMessage key={index}>
                                                    <div>
                                                        {' '}
                                                        <AddCartIcon
                                                            mobilePath={
                                                                warning
                                                            }
                                                            width={'19px'}
                                                            height={'19px'}
                                                        />
                                                    </div>
                                                    <div
                                                        style={{
                                                            marginLeft:
                                                                '10px',
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                fontFamily:
                                                                    'AvenirNextWorld Regular',
                                                                color: '#b56409',
                                                            }}
                                                        >
                                                            {msg?.subType}
                                                            {'-'}
                                                            {msg?.message}
                                                        </span>
                                                    </div>
                                                </WaringMessage>
                                            );
                                        })
                                        : null}
                                </RowContainer>
                                {cartPage && (
                                    <RowContainer
                                        alignItems={
                                            isBundlesChildren
                                                ? 'flex-start'
                                                : 'flex-end'
                                        }
                                        width={
                                            isBundlesChildren ? '30%' : '10%'
                                        }
                                        mbPadding={0}
                                        flexDirection={
                                            isBundlesChildren && 'row-reverse'
                                        }
                                        marginRight={
                                            isBundlesChildren && '13px'
                                        }
                                    >
                                        <AddCartButton
                                            className={
                                                isPlaceHolderAdded ||
                                                    isDeleteButtonPresent === false
                                                    ? 'disabled'
                                                    : ''
                                            }
                                            visibility={
                                                isDeleteButtonPresent === false
                                                    ? 'hidden'
                                                    : ''
                                            }
                                            id={`condensedview-delete-button-${productCFN || cfn || bom}`}
                                            onClick={() =>
                                                isChildItem
                                                    ? deleteProduct(
                                                        setOrItemDetails.productKey
                                                    )
                                                    : deleteProduct(
                                                        setOrItemDetails
                                                    )
                                            }
                                        >
                                            <AddCartIcon
                                                mobilePath={DeleteIcon}
                                                width={'19px'}
                                                height={'19px'}
                                            />
                                        </AddCartButton>
                                        {!isFromBundle && (
                                            <SetCount
                                                marginRight={marginRight}
                                                mbMarginRight={
                                                    isBundlesChildren && '10px'
                                                }
                                                fontSize={fontSize}
                                                marginTop={
                                                    isBundlesChildren
                                                        ? '5px'
                                                        : '15px'
                                                }
                                            >   {uom || type || isSet ?
                                                <Type
                                                    typeFontSize={typeFontSize}
                                                >
                                                    {isSet
                                                        ? t('common.setLabel') 
                                                        : uom || type}
                                                </Type> : null
                                                }
                                            </SetCount>
                                        )}
                                    </RowContainer>
                                )}
                            </ColumnContainer>
                            {!isFromBundle && (
                                <div style={{ marginLeft: '20px' }}>
                                    {basePrice &&
                                        isEquity &&
                                        !isSetDetailPage &&
                                        !isItemDetailPage ? (
                                        <div>
                                            <Title2>
                                                {`${t(
                                                    'common.tableView.unitPrice'
                                                )} ${getCurrencySymbol(
                                                    currencyISOCode ?? ''
                                                )}`}
                                                :
                                            </Title2>
                                            <span
                                                style={{
                                                    fontSize: '14px',
                                                    fontFamily:
                                                        'AvenirNextWorld Regular',
                                                    textTransform: 'lowercase',
                                                    textDecoration:
                                                        setOrItemDetails?.adjustedPrice &&
                                                        'line-through',
                                                    color: setOrItemDetails?.adjustedPrice
                                                        ? '#f70446'
                                                        : '#4C4C6C',
                                                    marginLeft: '10px',
                                                }}
                                            >
                                                {setCurrencyFormatWithoutSymbol(
                                                    basePrice
                                                )}
                                            </span>
                                            <span> </span>
                                            {setOrItemDetails?.adjustedPrice && (
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        fontFamily:
                                                            'AvenirNextWorld Regular',
                                                        textTransform:
                                                            'lowercase',
                                                        color: '#f70446',
                                                    }}
                                                >
                                                    {' '}
                                                    {setCurrencyFormatWithoutSymbol(
                                                        setOrItemDetails.adjustedPrice
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    ) : (
                                        ''
                                    )}

                                    {extPrice &&
                                        isEquity &&
                                        !isSetDetailPage &&
                                        !isItemDetailPage ? (
                                        <div>
                                            <Title2>
                                                {`${t(
                                                    'common.tableView.extPrice'
                                                )} ${getCurrencySymbol(
                                                    currencyISOCode ?? ''
                                                )}`}
                                                :
                                            </Title2>
                                            <span
                                                style={{
                                                    fontSize: '14px',
                                                    fontFamily:
                                                        'AvenirNextWorld Regular',
                                                    textTransform: 'lowercase',
                                                    textDecoration:
                                                        setOrItemDetails?.adjustedExtPrice &&
                                                        'line-through',
                                                    color: setOrItemDetails?.adjustedExtPrice
                                                        ? '#f70446'
                                                        : '#4C4C6C',
                                                    marginLeft: '10px',
                                                }}
                                            >
                                                {' '}
                                                {setCurrencyFormatWithoutSymbol(
                                                    extPrice
                                                )}
                                            </span>
                                            <span> </span>
                                            {setOrItemDetails?.adjustedExtPrice && (
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        fontFamily:
                                                            'AvenirNextWorld Regular',
                                                        textTransform:
                                                            'lowercase',
                                                        color: '#f70446',
                                                    }}
                                                >
                                                    {setCurrencyFormatWithoutSymbol(
                                                        setOrItemDetails.adjustedExtPrice
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {isEquity &&
                                        !isSetDetailPage &&
                                        !isItemDetailPage &&
                                        setOrItemDetails?.discount ? (
                                        <div>
                                            <span
                                                style={{
                                                    fontFamily:
                                                        'AvenirNextWorld Regular',
                                                    textTransform: 'lowercase',
                                                    color: '#f70446',
                                                }}
                                            >
                                                {' '}
                                                {setOrItemDetails.discount}{' '}
                                                {t('common.discount')}
                                            </span>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            )}
                            {isShippingScreen &&
                                !isTissueProduct &&
                                (shipDontShipSurgery !== 'NOT_VISIBLE' ||
                                    setOrItemDetails?.isReservationSet) &&
                                // !setOrItemDetails.shippingRequirement && 
                                (
                                    <BatchConatiner
                                        mbBottom={'6px'}
                                        height={
                                            isTransferSurgery()
                                                ? 'auto'
                                                : '35px'
                                        }
                                        margin={
                                            checked ? '0px 0px 0px 16px' : '0px'
                                        }
                                    >
                                        <BatchDropDown
                                            checkAll={checkAll}
                                            checked={
                                                !setOrItemDetails.shippingRequirement
                                            }
                                            countryISOCode={countryISOCode}
                                            selectedLocation={selectedLocation}
                                            setIsBatchSelected={
                                                setIsBatchSelected
                                            }
                                            isBatchSelected={isBatchSelected}
                                            allocatedData={allocatedData}
                                            setAllocatedData={setAllocatedData}
                                            setReservationBatch={
                                                setReservationBatch
                                            }
                                            product={setOrItemDetails}
                                            isShowCheckBox={false}
                                            isMessageDisplay={true}
                                            isShowLabelEmpty={false}
                                            isShowSetLocation={false}
                                            isShowDropDown={true}
                                        />
                                    </BatchConatiner>
                                )}
                            {isShippingScreen &&
                                setOrItemDetails?.batchAllocationError && (
                                    <ProductErrorText
                                        style={{ paddingLeft: '4%' }}
                                    >
                                        <AlertIcon
                                            src={AlertCircleOutline}
                                            height="14px"
                                            width="auto"
                                        />
                                        <div>
                                            {t(
                                                'scheduleSurgery.Shipping.ProductCard.batchAllocationError'
                                            )}
                                        </div>
                                    </ProductErrorText>
                                )}
                            {!cartPage &&
                                !isProductguidePage &&
                                !section == 'template' &&
                                isShippingScreen &&
                                !isTissueProduct &&
                                (shipDontShipSurgery !== 'NOT_VISIBLE' ||
                                    setOrItemDetails?.isReservationSet) && (
                                    <BatchDropDown
                                        checkAll={checkAll}
                                        checked={
                                            !setOrItemDetails.shippingRequirement
                                        }
                                        countryISOCode={countryISOCode}
                                        selectedLocation={selectedLocation}
                                        setIsBatchSelected={setIsBatchSelected}
                                        isBatchSelected={isBatchSelected}
                                        allocatedData={allocatedData}
                                        setAllocatedData={setAllocatedData}
                                        setReservationBatch={
                                            setReservationBatch
                                        }
                                        product={setOrItemDetails}
                                        isShowCheckBox={false}
                                        isMessageDisplay={true}
                                        isShowLabelEmpty={false}
                                        isShowSetLocation={false}
                                        isShowDropDown={true}
                                    />
                                )}
                        </>
                    ) : null}
                </RowContainer>
            </ItemsCardContainer>
        </>
    );
};

CondensedMobileView.prototype = {
    setOrItemDetails: PropTypes.object,
    checkBoxDetails: PropTypes.object,
};

export default CondensedMobileView;
